<template>
  <div>
    <SidebarVue ref="sidebar" />
    <Navgator
      ref="navgator"
      :barraTitulo="' Novo Atendimento Agendado'"
      :titulo="'novo atendimento agendado'"
    />
    <!--Formulário de Cadastro Cliente-->
    <div class="card-container">
      <div class="card">
        <div class="row g-2 p-2">
          <div class="card-title gy-4">
            <i class="bi bi-journal-text fs-5 icon-text-form"></i>
            <span class="txt-title-form">Dados do Cliente</span>
          </div>
        </div>
        <form @submit.prevent="cadastrar_cliente">
          <div class="row g-2 p-2">
            <!--Telefone-->
            <div class="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  :disabled="habilitar_telefone"
                  v-model="tel"
                  v-on:blur="vTel"
                />
                <label for="valid_nome">Telefone</label>
              </div>
            </div>
            <!--Telefone 2 -->
            <div class="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="cel"
                  :style="{ 'border-color': nomeBorderColor }"
                  v-on:blur="vCel"
                />
                <label for="valid_nome">Telefone 2</label>
              </div>
            </div>
            <!--Cliente-->
            <div class="col-12 col-sm-12 col-md-6 col-lg-8 col-xl-8">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="modal_nome"
                  :style="{ 'border-color': nomeBorderColor }"
                  v-on:blur="checkForm"
                  required
                />
                <label for="valid_nome">Nome</label>
              </div>
            </div>
            <!--Email-->
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <div class="form-floating txt-form-label">
                <input
                  type="email"
                  class="form-control txt-form-input"
                  v-model="email"
                  :style="{ 'border-color': nomeBorderColor }"
                  v-on:blur="validateEmail(email)"
                />
                <label for="valid_email">Email</label>
              </div>
            </div>
            <!--UF-->
            <div class="col-12 col-sm-6 col-md-2 col-lg-2 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  v-model="uf"
                  class="form-control txt-form-input"
                  list="datalistOptions"
                  id="estado"
                  autocomplete="off"
                />

                <label>UF</label>
                <datalist id="datalistOptions">
                  <option
                    v-for="opt in estados"
                    :data-value="opt.id"
                    :value="opt.sigla"
                    :key="opt.id"
                  ></option>
                </datalist>
              </div>
            </div>
            <!--Cidade-->
            <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
              <div class="form-floating txt-form-label">
                <input
                  v-model="cidade"
                  class="form-control txt-form-input"
                  list="datalistCidades"
                  id="estado"
                  autocomplete="off"
                />

                <label>Cidade</label>
                <datalist id="datalistCidades">
                  <option
                    v-for="opt in cidades"
                    :data-value="opt.id"
                    :value="opt.nome"
                    :key="opt.id"
                  ></option>
                </datalist>
              </div>
            </div>
            <!--Bairro-->
            <div class="col-12 col-sm-12 col-md-6 col-lg-12 col-xl-12">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="bairro"
                  autocomplete="off"
                />
                <label>Bairro</label>
              </div>
            </div>
            <!-- Seção: Ações -->
            <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
              <!-- Botões de Ação - Mobile (apenas ícones) -->
              <div class="d-flex d-md-none gap-2">
                <button
                  type="submit"
                  :disabled="habilitar_cadastro"
                  @click="cadastrar_cliente"
                  class="btn round-btn d-flex align-items-center justify-content-center"
                >
                  <i class="bi bi-plus-circle" title="Inserir"></i>
                </button>
                <button
                  type="submit"
                  :disabled="habilitar_proposta"
                  @click="update_cliente"
                  class="btn round-btn d-flex align-items-center justify-content-center"
                >
                  <i class="bi bi-pencil-square" title="Editar"></i>
                </button>
              </div>
              <!-- Botões de Ação - Tablet (768px - 991px) -->
              <div class="d-none d-md-flex d-lg-none gap-2">
                <button
                  type="submit"
                  :disabled="habilitar_cadastro"
                  @click="cadastrar_cliente"
                  class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                  style="font-size: 0.875rem; white-space: nowrap"
                >
                  <span>Cadastrar</span>
                </button>
                <button
                  type="submit"
                  :disabled="habilitar_proposta"
                  @click="update_cliente"
                  class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                  style="font-size: 0.875rem; white-space: nowrap"
                >
                  <span>Editar</span>
                </button>
              </div>
              <!-- Botões de Ação - Desktop (≥ 992px) -->
              <div class="d-none d-lg-flex gap-2">
                <button
                  type="submit"
                  :disabled="habilitar_cadastro"
                  @click="cadastrar_cliente"
                  class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                  style="font-size: 0.875rem; white-space: nowrap"
                >
                  <span>Cadastrar</span>
                </button>
                <button
                  type="submit"
                  :disabled="habilitar_proposta"
                  @click="update_cliente"
                  class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                  style="font-size: 0.875rem; white-space: nowrap"
                >
                  <span>Editar</span>
                </button>
              </div>
            </div>
          </div>
        </form>

        <div v-if="abrir_modal">
          <Message :msg="msg" v-show="msg" />
        </div>
      </div>
    </div>

    <!-- Formulário de Cadastro Proposta-->
    <div>
      <div class="card-container">
        <div class="card">
          <div class="row g-2 p-2">
            <div class="card-title gy-4">
              <i class="bi bi-journal-text fs-5 icon-text-form"></i>
              <span class="txt-title-form">Dados do Atendimento</span>
            </div>
          </div>
          <form @submit.prevent="onSubmit">
            <div class="row g-2 p-2">
              <!--Tipo Veiculo-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    :disabled="input_proposta"
                    v-model="tipo_veiculo"
                  >
                    <option value="0">Novo</option>
                    <option value="1">Usado</option>
                  </select>
                  <label>Tipo Veículo</label>
                </div>
              </div>
              <!--Vendedor-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    :disabled="input_proposta"
                    v-model="vendedor_inicial"
                    required
                  >
                    <option
                      v-for="item in vendedor.rows"
                      :value="item.vendedor.id"
                      :key="item.id"
                    >
                      {{ item.vendedor.username }}
                    </option>
                  </select>
                  <label>Vendedor</label>
                </div>
              </div>
              <!--Midia-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    :disabled="input_proposta"
                    required
                    v-model="midia_id"
                  >
                    <option
                      v-for="item in midia"
                      :value="item.id"
                      :key="item.id"
                    >
                      {{ item.descricao }}
                    </option>
                  </select>
                  <label>Midia</label>
                </div>
              </div>
              <!--Veiculo troca-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    id="valid_funcao"
                    :disabled="input_proposta"
                    required
                    v-model="searchTroca"
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                  <label>Veículo Troca</label>
                </div>
              </div>
              <!--Veiculo placa-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    :disabled="input_proposta || searchTroca !== '1'"
                    v-model="veiculo_placa"
                    maxlength="8"
                  />
                  <label>Placa Veículo</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    id="valid_funcao"
                    :disabled="input_proposta"
                    required
                    v-model="clientePCD"
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                  <label>Venda Direta</label>
                </div>
              </div>
            </div>
            <div class="row g-2 p-2">
              <!--Justificativa-->
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select fw-bold"
                    id="valid_funcao"
                    required
                    v-model="dialog_justificativa"
                  >
                    <option
                      v-for="item in justificativas"
                      :value="item.id"
                      :key="item.id"
                    >
                      {{ item.desc }}
                    </option>
                  </select>
                  <label>Justificativa</label>
                </div>
              </div>
            </div>
            <div class="row g-2 p-2">
              <!--Observação-->
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    :disabled="input_proposta"
                    v-model="obs"
                  />
                  <label>Observação</label>
                </div>
              </div>
            </div>
            <!-- Seção: Ações -->
            <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
              <!-- Botões de Ação - Mobile (apenas ícones) -->
              <div class="d-flex d-md-none gap-2">
                <button
                  type="submit"
                  :disabled="habilitar_proposta"
                  class="btn round-btn d-flex align-items-center justify-content-center"
                >
                  <i class="bi bi-plus-circle" title="Abrir"></i>
                </button>
              </div>
              <!-- Botões de Ação - Tablet (768px - 991px) -->
              <div class="d-none d-md-flex d-lg-none gap-2">
                <button
                  type="submit"
                  :disabled="habilitar_proposta"
                  class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                  style="font-size: 0.875rem; white-space: nowrap"
                >
                  <span>Abrir Atendimento</span>
                </button>
              </div>
              <!-- Botões de Ação - Desktop (≥ 992px) -->
              <div class="d-none d-lg-flex gap-2">
                <button
                  type="submit"
                  :disabled="habilitar_proposta"
                  class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                  style="font-size: 0.875rem; white-space: nowrap"
                >
                  <span>Abrir Atendimento</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Formulário de Fila de Espera-->
    <div v-if="fila_espera">
      <div class="card-container">
        <div class="card">
          <div class="row g-2 p-2">
            <div class="card-title gy-4 linha">
              <i class="bi bi-journal-text fs-5 icon-text-form"></i>
              <span class="txt-title-form">Dados da Proposta</span>
            </div>
          </div>
          <form @submit.prevent="onSubmitEspera">
            <div class="row g-2 p-2">
              <div class="card-title">
                <i class="bi bi-info-circle icon-text-form"></i>
                <span class="txt-title-modal"
                  >No momento não temos vendedores livres, adicione o cliente à
                  fila de espera!</span
                >
              </div>

              <!--Tipo Veiculo-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    :disabled="input_proposta"
                    v-model="tipo_veiculo"
                  >
                    <option value="0">Novo</option>
                    <option value="1">Usado</option>
                  </select>
                  <label>Tipo Veículo</label>
                </div>
              </div>
              <!--Midia-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    :disabled="input_proposta"
                    required
                    v-model="midia_id"
                  >
                    <option
                      v-for="item in midia"
                      :value="item.id"
                      :key="item.id"
                    >
                      {{ item.descricao }}
                    </option>
                  </select>
                  <label>Midia</label>
                </div>
              </div>
              <!--Veiculo troca-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    id="valid_funcao"
                    :disabled="input_proposta"
                    required
                    v-model="searchTroca"
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                  <label>Veículo Troca</label>
                </div>
              </div>
              <!--Veiculo placa-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    :disabled="input_proposta || searchTroca !== '1'"
                    v-model="veiculo_placa"
                    maxlength="8"
                  />
                  <label>Placa Veículo</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    id="valid_funcao"
                    :disabled="input_proposta"
                    required
                    v-model="clientePCD"
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                  <label>Venda Direta</label>
                </div>
              </div>
            </div>
            <div class="row g-2 p-2">
              <!--Observação-->
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-12">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    :disabled="input_proposta"
                    v-model="obs"
                  />
                  <label>Observação</label>
                </div>
              </div>
            </div>
            <div class="row g-2 p-2">
              <div class="d-md-none">
                <div class="form-floating txt-form-label">
                  <button
                    type="submit"
                    :disabled="habilitar_proposta"
                    class="btn round-btn"
                  >
                    <i class="bi bi-plus-circle" title="Abrir"></i>
                  </button>
                </div>
              </div>
              <div
                class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 d-none d-md-block"
              >
                <div class="form-floating txt-form-label">
                  <button
                    type="submit"
                    :disabled="habilitar_proposta"
                    class="btn btn-lg btn-form align-self-end"
                  >
                    <span>Fila Espera</span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal"
      id="modal_cadastrar_cliente"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pencil-square icon-text-logout"></i>
            <span class="txt-title-modal"> Cadastrar Cliente</span>
            <button
              class="btn-close"
              type="button"
              data-bs-toggle="modal"
              @click="close_modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <p class="fw-bold">
              Cliente não encontrado na base de dados, deseja cadastrar?
            </p>
          </div>
          <div class="modal-footer">
            <div class="d-md-none">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    data-bs-dismiss="modal"
                    @click="close_modal"
                  >
                    <i class="bi bi-x-circle" title="Não"></i>
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    @click="modal_cliente"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-check-circle" title="Sim"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="d-none d-md-block">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                    @click="close_modal"
                  >
                    Não
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                    @click="modal_cliente"
                  >
                    Sim
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Justificativa -->
    <div
      class="modal"
      id="modal_justificar"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pencil-square icon-text-logout"></i>
            <span class="txt-title-modal">
              Você está trocando a ordem do vendedor!</span
            >
            <button
              class="btn-close"
              type="button"
              data-bs-toggle="modal"
              @click="fechar_sem_justificar"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <p class="txt-form-input fw-bold">
              Escolha um das justificativas abaixo para prosseguir!
            </p>
            <div class="form-floating txt-form-label">
              <select
                class="form-select fw-bold"
                id="valid_funcao"
                required
                v-model="dialog_justificativa"
              >
                <option
                  v-for="item in justificativas"
                  :value="item.id"
                  :key="item.id"
                >
                  {{ item.desc }}
                </option>
              </select>
              <label class="fw-bold">Justificativa</label>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-md-none">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    data-bs-dismiss="modal"
                    @click="fechar_sem_justificar"
                  >
                    <i class="bi bi-x-circle" title="Fechar sem Justificar"></i>
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    @click="Justificar"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-check-circle" title="Justificar"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="d-none d-md-block">
              <div class="row">
                <div class="col-4">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                    @click="Justificar"
                  >
                    Justificar
                  </button>
                </div>
                <div class="col-8">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                    @click="fechar_sem_justificar"
                  >
                    Fechar sem Justificar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RodapeVue />
  </div>
</template>
<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import userService from "../../services/user.service";
import Message from "../../components/modal/Message.vue";
import axios from "axios";
import TokenService from "../../services/token.service";
import jwt_decode from "jwt-decode";
import RodapeVue from "../../components/menu/Rodape.vue";
import Navgator from "../../components/menu/NavgatorAt.vue";

export default {
  name: "Atendimento",
  components: {
    SidebarVue,
    Navgator,
    Message,
    RodapeVue
  },

  data() {
    return {
      propostas_at: [],
      vendedor_nome: "",
      fila_espera: "",
      company_id: "",
      //Paginação
      page: 1,
      totalPages: 0,
      totalItems: 0,
      pageSizes: [5, 10, 15, 35],
      pageSize: 5,

      //Paginação Midia
      page_midia: 1,
      totalPages_midia: 0,
      totalItems_midia: 0,
      pageSizes_midia: 1000,
      pageSize_midia: 1000,

      //Controle
      btn_cadastrar: false,
      btn_editar: false,
      msg: "",
      abrir_modal: false,
      empresa_id: [],

      valid: false,
      vtroca: false,
      reveal: false,
      habilitar: true,
      modelo: [],
      selectedModelo: [],
      marca: [],
      vendedor: [],
      midia: [],
      familia: [],
      selectedFamilia: null,

      modal: false,
      vendedor_inicial: "",
      vend_ini: "",
      status_vendedor: "",

      options: [
        { value: "Indisponível", text: "Em Atendimento", color: "red" },
        { value: "Disponível", text: "Disponível", color: "green" }
      ],

      dialog_just: false,
      dialog_cliente: false,
      dialog_justificativa: 0,
      justificativas: [
        { id: 0, desc: "Cliente solicitou a troca do vendedor" },
        { id: 1, desc: "Cliente agendado pelo vendedor" },
        {
          id: 2,
          desc: "Cliente veio por agendamento mas o vendedor não se encontrava no local"
        }
      ],
      message: "",
      dialog: "",
      dialog_cad_cliente: false,

      //Campos do Atendimento
      tipo_veiculo: 0,
      // itensRetorno: ["Sim", "Não"],
      // searchVend: 1,
      // itensTipo: [
      //   { desc: "Novos", value: 1 },
      //   { desc: "Usados", value: 0 },
      // ],
      searchTroca: 0,
      clientePCD: 0,
      troca: [{ desc: "SIM" }, { desc: "NÃO" }],
      user_id: "",
      cliente_id: "",
      clientes: [],
      email: "",
      tel: "",
      cel: "",
      marca_id: "",
      modelo_id: "",
      familia_id: "",
      familia_desc: "",
      midia_id: "",
      obs: "",
      tipo: "",
      bairro: "",
      uf: "",
      cidade: "",
      veiculo_placa: "",

      modal_nome: "",
      modal_cpfcnpj: "",
      modal_tel: "",
      input_cliente: true,

      descriptionLimit: 60,
      descriptionLimit2: 60,
      descriptionLimit3: 60,
      descriptionLimit4: 60,
      entries: [],
      entries2: [],
      entries3: [],
      entries4: [],
      isLoading: false,
      model: null,
      search: null,
      isLoading2: false,
      model2: null,
      input_cpf_cnpj: null,
      search2: null,
      isLoading3: false,
      model3: null,
      search3: null,
      isLoading4: false,
      model4: null,
      search4: null,

      totalItems2: null,
      totalItems3: null,
      totalItems4: null,

      //Campos cadastro veiculo usado
      placa: "",
      kilometragem: "",
      anoFabricacao: "",
      anoModelo: "",

      //Título e Links de navegação
      item_titulo: "Menu - Novo Atendimento",
      id_vend: 2,
      celBorderColor: "",
      nomeBorderColor: "",
      habilitar_proposta: true,
      habilitar_cadastro: true,
      habilitar_telefone: false,
      retorno: false,
      input_proposta: true,
      cidades: [],
      estados: [
        { id: 11, sigla: "RO" },
        { id: 12, sigla: "AC" },
        { id: 13, sigla: "AM" },
        { id: 14, sigla: "RR" },
        { id: 15, sigla: "PA" },
        { id: 16, sigla: "AP" },
        { id: 17, sigla: "TO" },
        { id: 21, sigla: "MA" },
        { id: 22, sigla: "PI" },
        { id: 23, sigla: "CE" },
        { id: 24, sigla: "RN" },
        { id: 25, sigla: "PB" },
        { id: 26, sigla: "PE" },
        { id: 27, sigla: "AL" },
        { id: 28, sigla: "SE" },
        { id: 29, sigla: "BA" },
        { id: 31, sigla: "MG" },
        { id: 32, sigla: "ES" },
        { id: 33, sigla: "RJ" },
        { id: 35, sigla: "SP" },
        { id: 41, sigla: "PR" },
        { id: 42, sigla: "SC" },
        { id: 43, sigla: "RS" },
        { id: 50, sigla: "MS" },
        { id: 51, sigla: "MT" },
        { id: 52, sigla: "GO" },
        { id: 53, sigla: "DF" }
      ]
    };
  },
  mounted() {
    this.getToken();
    this.retrieveMidia();
    //this.buscarVendedorPorTipo(this.tipo_veiculo);
    this.retrieveVendedorDispo();
    this.retrieveCidade();
    //this.retrievePropostas();
  },

  watch: {
    search() {
      // Items have already been loaded
      if (this.items.length > 0) return;

      // Items have already been requested
      if (this.isLoading) return;

      this.isLoading = true;

      // Lazily load input items
      fetch(`${process.env.VUE_APP_API_URL}clientes`)
        .then((res) => res.json())
        .then((res) => {
          console.log(res);
          const { totalItems, cliente } = res;
          this.count = totalItems;
          this.entries = cliente;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.abrir_modal = true;
            this.msg = error.response.data.message;
          }
        })
        .finally(() => (this.isLoading = false));
    },
    search2(val) {
      if (val != null) {
        var valor = val;
      } else {
        console.log(val);
      }

      console.log("items 22222 " + valor);
      // Items have already been loaded
      if (this.items2.length > 0) return;

      // Items have already been requested
      if (this.isLoading2) return;

      this.isLoading2 = true;

      // Lazily load input items
      fetch(`${process.env.VUE_APP_API_URL}clientes`)
        .then((res) => res.json())
        .then((res) => {
          console.log(res);
          const { totalItems2, cliente } = res;
          this.count = totalItems2;
          this.entries2 = cliente;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.abrir_modal = true;
            this.msg = error.response.data.message;
          }
        })
        .finally(() => (this.isLoading2 = false));
    },
    search3() {
      // Items have already been loaded
      if (this.items3.length > 0) return;

      // Items have already been requested
      if (this.isLoading3) return;

      this.isLoading3 = true;

      // Lazily load input items
      fetch(`${process.env.VUE_APP_API_URL}modelo`)
        .then((res) => res.json())
        .then((res) => {
          console.log(res);
          const { totalItems3, modelo_veiculo } = res;
          this.count = totalItems3;
          this.entries3 = modelo_veiculo;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.abrir_modal = true;
            this.msg = error.response.data.message;
          }
        })
        .finally(() => (this.isLoading3 = false));
    },
    search4() {
      // Items have already been loaded
      if (this.items4.length > 0) return;

      // Items have already been requested
      if (this.isLoading4) return;

      this.isLoading4 = true;

      // Lazily load input items
      fetch(`${process.env.VUE_APP_API_URL}modelo`)
        .then((res) => res.json())
        .then((res) => {
          const { totalItems4, modelo_veiculo } = res;
          this.count = totalItems4;
          this.entries4 = modelo_veiculo;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.abrir_modal = true;
            this.msg = error.response.data.message;
          }
        })
        .finally(() => (this.isLoading4 = false));
    },
    searchTroca(newValue) {
      // Limpa o valor de veiculo_placa se 'Veículo Troca' for igual a 'Não'
      if (newValue === "0") this.veiculo_placa = "";
    },
    tipo_veiculo(newVal) {
      this.buscarVendedorPorTipo(newVal);
    }
  },
  methods: {
    getToken() {
      const accessToken = TokenService.getLocalAccessToken();

      // Obter o token de atualização (refresh token)
      TokenService.getLocalRefreshToken();

      // Obter o usuário completo (incluindo os tokens) se necessário
      TokenService.getUser();
      this.nome_gerente = TokenService.getUser().username;
      this.vendedor_inicial_prop = TokenService.getUser().id;
      const decodedToken = jwt_decode(accessToken);
      console.log(decodedToken);
      this.company_id = decodedToken.company;
      this.user_id = decodedToken.id;
    },
    async buscarVendedorPorTipo(tipo) {
      try {
        // Chama a API passando o tipo de veículo como parâmetro
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}buscar_vendedor`,
          {
            params: { empresa_id: this.company_id, tipo }
          }
        );
        console.log("Vendedor por tipo", response.data);
        // Pega o primeiro vendedor da lista filtrada
        if (response.data.nome) {
          this.vendedor_nome = response.data.nome;
          this.vendedor_inicial = response.data.id;
          // ou qualquer outro campo que você precise armazenar
        } else {
          this.vendedor_nome = "Nenhum vendedor disponível";
        }
      } catch (error) {
        console.error("Erro ao buscar vendedor:", error);
        this.vendedor_nome = "Erro ao carregar vendedor";
      }
    },
    getStatusClass(item) {
      const option = this.options.find((o) => o.value === item.status_vendedor);
      return `status-${option.color}`;
    },
    open_modal() {
      const switchModal = () => {
        const modal = document.getElementById("modal_cadastrar_cliente");
        modal.style.display = "block";
      };
      switchModal();
    },
    open_modal_justificar() {
      const switchModal = () => {
        const modal = document.getElementById("modal_justificar");
        modal.style.display = "block";
      };
      switchModal();
    },
    close_modal() {
      const switchModal = () => {
        const modal = document.getElementById("modal_cadastrar_cliente");
        modal.style.display = "none";
      };
      switchModal();
    },
    //Habilitar cadastro de Clientes
    modal_cliente() {
      this.input_cliente = false;

      this.nomeBorderColor = "green"; // Por exemplo, a cor verde indica que o campo está habilitado
      this.emailBorderColor = "green";
      this.telBorderColor = "green";
      this.celBorderColor = "green";
      this.habilitar_cadastro = false;
      this.close_modal();
    },

    async cadastrar_cliente() {
      try {
        if (this.cel === this.tel) {
          // Exemplo: mudar a cor da borda dos campos para vermelho
          this.celBorderColor = "red";
          this.telBorderColor = "red";
          // Exemplo: exibir mensagem de erro
          this.abrir_modal = true;
          this.msg = "Os campos Telefone e Telefone 2 não podem ser iguais.";
          setTimeout(() => (this.abrir_modal = false), 4000);
        }

        const response = await fetch(`${process.env.VUE_APP_API_URL}cliente`, {
          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            usuario_id: this.$store.state.auth.user.id,
            nome: this.modal_nome,
            tel: this.tel,
            cel: this.cel,
            email: this.email,
            bairro: this.bairro,
            cidade: this.cidade,
            uf: this.uf
          })
        });
        const dados = await response.json();
        console.log(dados.message);
        if (!response.ok) {
          this.abrir_modal = true;
          this.msg = dados.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        } else {
          this.cliente_id = dados.data.id;
          this.habilitar_cadastro = true;
          this.habilitar_telefone = true;
          this.input_cliente = true;
          this.input_proposta = false;
          this.habilitar_proposta = false;
          this.abrir_modal = true;
          this.msg = dados.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      } catch (error) {
        console.log(error);
        this.abrir_modal = true;
        this.msg = error.response.data.message;
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },

    async retrieveCidade() {
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          this.page,
          this.pageSize
        );
        userService.getCidades(params).then((response) => {
          const { cidade } = response.data;
          this.cidades = cidade;
        });
      } catch (error) {
        console.log("Erro cidade", error);
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },

    async update_cliente() {
      try {
        if (this.cel === this.tel) {
          // Exemplo: mudar a cor da borda dos campos para vermelho
          this.celBorderColor = "red";
          this.telBorderColor = "red";
          // Exemplo: exibir mensagem de erro
          this.abrir_modal = true;
          this.msg = "Os campos Telefone e Telefone 2 não podem ser iguais.";
          setTimeout(() => (this.abrir_modal = false), 4000);
          return;
        }
        const token = this.$store.state.auth.user.accessToken;
        const headers = {
          "x-access-token": token
        };
        const dados = {
          id: this.cliente_id,
          id_userCad: this.$store.state.auth.user.id,
          nome: this.modal_nome,
          telefone: this.tel,
          celular: this.cel,
          email: this.email
        };

        const response = await axios.put(
          `${process.env.VUE_APP_API_URL}cliente/${this.cliente_id}`,
          dados,
          { headers }
        );
        const resp = JSON.stringify(response.status);
        if (resp == 200) {
          this.abrir_modal = true;
          this.msg = "Cliente atualizado com sucesso!";
          setTimeout(() => (this.abrir_modal = false), 9000);
        }
      } catch (error) {
        console.log(error);
        this.abrir_modal = true;
        this.msg = error.response.data.message;
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    //Gravar função no banco de dados
    async onSubmit() {
      console.log("Gravando uma Proposta");
      if (this.midia_id) {
        try {
          const id_userCad = this.$store.state.auth.user.id;
          await fetch(`${process.env.VUE_APP_API_URL}proposta_agendamento`, {
            method: "POST",

            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              user_id: id_userCad,
              retorno: this.retorno,
              avaliacao: this.searchTroca,
              cliente_pcd: this.clientePCD,
              placa_avaliacao: this.veiculo_placa,
              obs: this.obs,
              justificativa: this.dialog_justificativa,
              id_vendedor_fila: this.vend_ini,
              status_vendedor: this.status_vendedor,
              empresa_id: this.company_id,
              midia_id: this.midia_id,
              vendedor_id: this.vendedor_inicial,
              cliente_id: this.cliente_id,
              tipo_veiculo: this.tipo_veiculo
            })
          })
            .then((data) => {
              if (!data.ok) {
                if (data.status == 400) {
                  this.abrir_modal = true;
                  this.msg =
                    "O sistema está em atualização. Atualize a página para verificar se terminou!";
                }
                throw Error(data.status);
              }
              return data.json();
            })
            .then((resposta) => {
              if (resposta.StatusOk == 200) {
                this.abrir_modal = true;
                this.msg = resposta.message;
                setTimeout(
                  () => (
                    (this.abrir_modal = false),
                    this.$router.push("/atendimento/dashboard")
                  ),
                  4000
                );
              }
              if (resposta.StatusOk == 1) {
                this.abrir_modal = true;
                this.msg =
                  "Sistema será redirecionado a tela de login, por inatividade";

                setTimeout(
                  () => (
                    (this.abrir_modal = false),
                    this.$store.dispatch("auth/logout"),
                    this.$router.push("/login")
                  ),
                  4000
                );
              }
              if (resposta.StatusOk == 204) {
                this.abrir_modal = true;
                this.msg = resposta.message;
                setTimeout(() => (this.abrir_modal = false), 4000);
              }
            })
            .catch((error) => {
              if (error.response.status == 400) {
                this.abrir_modal = true;
                this.msg = error.response.data.message;
              }
            });
        } catch (error) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      } else {
        this.abrir_modal = true;
        this.msg = "O campo mídia é obrigatório!";
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    async onSubmitEspera() {
      console.log("Gravando uma Proposta em Espera");
      if (this.midia_id) {
        try {
          const id_userCad = this.$store.state.auth.user.id;
          await fetch(`${process.env.VUE_APP_API_URL}proposta_espera`, {
            method: "POST",

            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              user_id: id_userCad,
              retorno: this.retorno,
              avaliacao: this.searchTroca,
              cliente_pcd: this.clientePCD,
              placa_avaliacao: this.veiculo_placa,
              obs: this.obs,
              justificativa: this.dialog_justificativa,
              empresa_id: this.company_id,
              midia_id: this.midia_id,
              cliente_id: this.cliente_id,
              tipo_veiculo: this.tipo_veiculo
            })
          })
            .then((data) => {
              if (!data.ok) {
                if (data.status == 400) {
                  this.abrir_modal = true;
                  this.msg =
                    "O sistema está em atualização. Atualize a página para verificar se terminou!";
                }
                throw Error(data.status);
              }
              return data.json();
            })
            .then((resposta) => {
              if (resposta.StatusOk == 200) {
                this.abrir_modal = true;
                this.msg = resposta.message;
                setTimeout(
                  () => (
                    (this.abrir_modal = false),
                    this.$router.push("/atendimento/dashboard")
                  ),
                  4000
                );
              }
              if (resposta.StatusOk == 1) {
                this.abrir_modal = true;
                this.msg =
                  "Sistema será redirecionado a tela de login, por inatividade";

                setTimeout(
                  () => (
                    (this.abrir_modal = false),
                    this.$store.dispatch("auth/logout"),
                    this.$router.push("/login")
                  ),
                  4000
                );
              }
              if (resposta.StatusOk == 204) {
                this.abrir_modal = true;
                this.msg = resposta.message;
                setTimeout(() => (this.abrir_modal = false), 4000);
              }
            })
            .catch((error) => {
              if (error.response.status == 400) {
                this.abrir_modal = true;
                this.msg = error.response.data.message;
              }
            });
        } catch (error) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      } else {
        this.abrir_modal = true;
        this.msg = "O campo mídia é obrigatório!";
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },

    async retrievePropostas() {
      try {
        const params = {
          empresaID: this.company_id,
          user_id: this.user_id
        };
        const response = await userService.getPropostaRecepcao(params);
        console.log("Dados vindo da consulta - 00001 ");
        console.log(response.data.response);

        this.propostas_at = response.data.response;
      } catch (error) {
        console.log(error);
      }
    },

    //Buscar dados no banco de dados
    getRequestParams(page, pageSize, empresa_id, id_vend) {
      let params = {};
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (empresa_id) {
        params["empresa_id"] = empresa_id;
      }
      if (id_vend) {
        params["id_vend"] = id_vend;
      }
      return params;
    },
    getRequestParamsCliente(telefone) {
      let params = {};
      if (telefone) {
        params["telefone"] = telefone;
      }
      return params;
    },
    getRequestParamsMidias(searchTitle, page_midia, pageSize_midia) {
      let params = {};
      if (searchTitle) {
        params["nome"] = searchTitle;
      }
      if (page_midia) {
        params["page"] = page_midia - 1;
      }
      if (pageSize_midia) {
        params["size"] = pageSize_midia;
      }
      return params;
    },

    async retrieveModelo() {
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          this.page,
          this.pageSize
        );
        userService
          .getModelo(params)
          .then((response) => {
            const { modelo_veiculo, totalPages } = response.data;
            this.modelo = modelo_veiculo;
            this.totalPages = totalPages;
            console.log(response.data);
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.abrir_modal = true;
              this.msg = error.response.data.message;
            }
          });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },

    async retrieveMarca() {
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          this.page,
          this.pageSize
        );
        userService
          .getMarca(params)
          .then((response) => {
            const { marcas, totalPages } = response.data;
            this.marca = marcas;
            this.totalPages = totalPages;
            console.log(response.data);
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.abrir_modal = true;
              this.msg = error.response.data.message;
            }
          });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },
    async retrieveFamilia() {
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          this.page,
          this.pageSize
        );
        userService
          .getFamilia_at(params)
          .then((response) => {
            const { familia_veiculo, totalPages } = response.data;
            this.familia = familia_veiculo;
            this.totalPages = totalPages;
            console.log(response.data);
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.abrir_modal = true;
              this.msg = error.response.data.message;
            }
          });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },
    async retrieveMidia() {
      try {
        const params = this.getRequestParamsMidias(
          this.searchTitle,
          this.page_midia,
          this.pageSize_midia
        );
        userService
          .getMidia(params)
          .then((response) => {
            const { midias } = response.data;

            this.midia = midias;

            console.log(response.data);
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.abrir_modal = true;
              this.msg = error.response.data.message;
            }
          });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },
    async retrieveVendedorDispo() {
      try {
        const params = this.getRequestParams(
          this.page,
          this.pageSize,
          this.company_id,
          this.id_vend
        );

        userService
          .getVendedorAgendado(params)
          .then((response) => {
            if (response.data.count == 0) {
              this.fila_espera = true;
            } else {
              this.fila_espera = false;
              this.vendedor_inicial = response.data.rows[0].vendedor.id;
              this.vendedor_nome = response.data.rows[0].vendedor.username;
              this.vendedor = response.data;
              console.log("Vendedores", this.vendedor_nome);
              console.log("Buscando vendedores", response.data);
            }
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.abrir_modal = true;
              this.msg = error.response.data.message;
            }
          });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },
    handlePageChange(value) {
      this.page = value;
      this.retrieveCidades();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrieveCidades();
    },
    getDisplayFunction(role) {
      return {
        id: role.id,
        nome: role.name.substr(0, 20) + "...",
        description: role.description.substr(0, 20) + "..."
      };
    },
    validate() {
      this.$refs.form.validate();
    },
    async dados() {
      if (this.selectedFamilia) {
        await axios
          .get(`${process.env.VUE_APP_API_URL}modelos`, {
            params: { familiaVeiculoId: this.selectedFamilia }
          })
          .then((response) => {
            this.modelo = response.data.rows;
            console.log(response.data.rows);
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.abrir_modal = true;
              this.msg = error.response.data.message;
            }
          });

        // for (let i = 0; i < this.modelo.length; i++) {
        //   if (this.familia_id == this.modelo[i]["familiaVeiculoId"]) {
        //     console.log(this.modelo[i]);
        //     this.marca_id = this.modelo[i]["familia_veiculo"]["marcaVeiculoId"];
        //     this.familia_desc = this.modelo[i]["familia_veiculo"]["descricao"];
        //     this.familia_id = this.modelo[i]["familiaVeiculoId"];
        //     this.modelo_id = this.modelo[i]["id"];

        //     console.log("Marca----");
        //     console.log(this.marca_id);
        //     console.log("Familia");
        //     console.log(this.familia_desc);
        //     console.log(this.familia_id);
        //     console.log("Modelo");
        //     console.log(this.modelo_id);
        //     //JSON.parse(JSON.stringify(custo_variaveis))
        //   }
        // }
      } else {
        this.modelo = [];
      }
      //Validação campo Modelo
      //   if (this.model3 != null) {
      //     this.marca_id = this.model3.marcaVeiculo;
      //     this.familia_desc = this.model3.familiaVeiculo.descricao;
      //     this.familia_id = this.model3.familiaVeiculo.id;
      //     this.modelo_id = this.model3.id;

      //     console.log("Marca----")
      //     console.log(this.marca_id);
      //     console.log("Familia")
      //     console.log(this.familia_desc);
      //     console.log(this.familia_id);
      //     console.log("Modelo");
      //     console.log(this.modelo_id);

      //   }
      if (this.modal_nome != null) {
        console.log(this.modal_nome);
      }
      //pesquisa por cpf ou cnpj
      // if (this.model2 != null) {
      //   console.log(this.model2);
      //  // this.email = this.model2.email;
      //  // this.tel = this.model2.tel;
      //  // this.cel = this.model2.cel;
      //  // this.model = this.model2.nome;
      //   //this.cliente_id = this.model2.id;
      //   //this.buscaVendedor(this.model2.id);
      // }else{
      //   console.log("Vazio")
      // }
      //pesquisa por nome
      if (this.model != null) {
        this.buscaVendedor(this.model.id);
      }
    },

    checar_vendedor() {
      if (this.vendedor_inicial != this.vend_ini) {
        console.log("Diferente");
        this.atualizar_status_vendedor();
        // console.log(item);
        // console.log(this.vendedor_inicial)
        // console.log(this.vendedor)
        this.open_modal_justificar();
        // this.status_vendedor = this.vendedor_inicial.status_vendedor;
        // console.log("Status do vendedo na função checar vendedor")
        console.log(this.status_vendedor);
      }
    },

    atualizar_status_vendedor() {
      const vendedorSelecionado = this.vendedor.find(
        (v) => v.id === this.vendedor_inicial
      );
      if (vendedorSelecionado) {
        this.status_vendedor = vendedorSelecionado.status_vendedor;
      }
    },

    Justificar() {
      const switchModal = () => {
        const modal = document.getElementById("modal_justificar");
        modal.style.display = "none";
      };
      switchModal();
    },

    fechar_sem_justificar() {
      const switchModal = () => {
        const modal = document.getElementById("modal_justificar");
        modal.style.display = "none";
        //this.retrieveVendedorDispo();
      };
      switchModal();
    },

    async buscaVendedor(id) {
      try {
        userService
          .getPropostaClienteId(id)
          .then((response) => {
            const result = response.data.count;
            if (this.model != null) {
              return;
            }
            if (this.model2 != null) {
              return;
            }
            if (result > 0) {
              this.modal = true;
              this.dialog = true;
              this.message = "Esse cliente já está em atendimento!";
              this.model = "";
            } else {
              this.modal_cpfcnpj = this.email = this.model.email;
              this.tel = this.model.tel;
              this.cel = this.model.cel;
              this.cliente_id = this.model.id;
              this.model2 = this.items.cpfCnpj;
              this.habilitar = false;
            }
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.abrir_modal = true;
              this.msg = error.response.data.message;
            }
          });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },

    vData() {
      var cpf_cnpj = this.modal_cpfcnpj;

      ///Validação do CPF/CNPJ
      if (this.formata_cpf_cnpj(cpf_cnpj)) {
        this.modal_cpfcnpj = this.formata_cpf_cnpj(cpf_cnpj);

        console.log(this.modal_cpfcnpj);
        try {
          const params = this.getRequestParamsCliente(this.modal_cpfcnpj);

          userService
            .getClientes(params)
            .then((response) => {
              const cliente = response.data;
              console.log("Resultado Clientes");
              console.log(response.data);
              if (response.data == "Não encontrado") {
                this.open_modal();
              }

              if (cliente != null) {
                this.cliente_id = cliente["id"];
                console.log(this.cliente_id);
                try {
                  userService
                    .getPropostaClienteId(this.cliente_id)
                    .then((response) => {
                      const result = response.data.count;
                      if (result > 0) {
                        this.modal = true;
                        this.dialog = true;
                        this.message = "Esse cliente já está em atendimento!";
                      } else {
                        this.modal_nome = cliente["nome"];
                        this.email = cliente["email"];
                        this.tel = cliente["tel"];
                        this.cel = cliente["cel"];
                        this.habilitar = false;
                        console.log(response.data);
                      }
                    });
                } catch (error) {
                  if (error.response.status == 400) {
                    this.abrir_modal = true;
                    this.msg = error.response.data.message;
                  }
                }
              } else {
                this.open_modal();
                console.log("Cliente não cadastrado deseja cadastrar?");
              }
            })
            .catch((error) => {
              if (error.response.status == 400) {
                this.abrir_modal = true;
                this.msg = error.response.data.message;
              }
            });
        } catch (error) {
          if (error.response.status == 400) {
            this.abrir_modal = true;
            this.msg = error.response.data.message;
          }
        }
      } else {
        this.dialog_cad_cliente = true;
        this.modal = true;
        this.message = "CPF ou CNPJ inválido!";
      }
    },

    vTel() {
      var telefone = this.tel;
      this.tel = this.tel.replace(/\D/g, "");
      if (this.tel.length >= 10 && this.tel.length <= 11) {
        this.tel = this.formata_tel(telefone);
        try {
          const params = this.getRequestParamsCliente(this.tel);
          userService.getClientes(params).then((response) => {
            const cliente = response.data;
            if (response.data == "Não encontrado") {
              this.open_modal();
            } else {
              this.cliente_id = cliente["id"];
              this.modal_nome = cliente["nome"];
              this.email = cliente["email"];
              this.cel = cliente["cel"];
              this.retorno = true;
              this.habilitar_proposta = false;
              this.input_proposta = false;
            }
          });
        } catch (error) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
          setTimeout(() => (this.abrir_modal = false), 4000);
        }
      } else {
        this.abrir_modal = true;
        this.msg = "Número de telefone incorreto";
        this.tel = "";
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    vCel() {
      var telefone = this.cel;
      this.cel = this.cel.replace(/\D/g, "");
      console.log(this.cel);
      if (this.cel.length >= 10 && this.cel.length <= 11) {
        this.cel = this.formata_tel(telefone);
      } else {
        this.abrir_modal = true;
        this.msg = "Número de telefone incorreto";
        this.cel = "";
        setTimeout(() => (this.abrir_modal = false), 4000);
      }

      if (this.tel == this.cel) {
        this.abrir_modal = true;
        this.msg = "Telefones não podem ser iguais!";
        this.cel = "";
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },

    verifica_tel(valor) {
      // Garante que o valor é uma string
      valor = valor.toString();

      // Remove caracteres inválidos do valor
      valor = valor.replace(/[^0-9]/g, "");

      // Verifica CPF
      if (valor.length === 10) {
        return "TELEFONE";
      }

      // Verifica CNPJ
      else if (valor.length === 11) {
        return "CELULAR";
      }

      // Não retorna nada
      else {
        return false;
      }
    },

    formata_tel(valor) {
      // O valor formatado
      var formatado = false;

      // Verifica se é CPF ou CNPJ
      var valida = this.verifica_tel(valor);

      // Garante que o valor é uma string
      valor = valor.toString();

      // Remove caracteres inválidos do valor
      valor = valor.replace(/[^0-9]/g, "");

      // Valida CPF
      if (valida === "TELEFONE") {
        // Verifica se o CPF é válido

        // Formata o CPF ###.###.###-##
        formatado = valor.substr(0, 2) + " ";
        formatado += valor.substr(2, 4) + "-";
        formatado += valor.substr(6, 4) + "";
        //this.cadastrar_cliente();
      }

      // Valida CNPJ
      else if (valida === "CELULAR") {
        // Verifica se o CNPJ é válido

        // Formata o CNPJ ##.###.###/####-##
        formatado = valor.substr(0, 2) + " ";
        formatado += valor.substr(2, 5) + "-";
        formatado += valor.substr(7, 4) + "";
        //this.cadastrar_cliente();
      } else {
        formatado = valor;

        // this.dialog = true,
        // this.modal = true,
        // this.message = "Formato do Telefone está incorreto!"
        // console.log(this.dialog);
      }

      console.log(formatado);

      // Retorna o valor
      return formatado;
    },

    verifica_cpf_cnpj(valor) {
      // Garante que o valor é uma string
      valor = valor.toString();

      // Remove caracteres inválidos do valor
      valor = valor.replace(/[^0-9]/g, "");

      // Verifica CPF
      if (valor.length === 11) {
        return "CPF";
      }

      // Verifica CNPJ
      else if (valor.length === 14) {
        return "CNPJ";
      }

      // Não retorna nada
      else {
        return false;
      }
    },

    calc_digitos_posicoes(digitos, posicoes = 10, soma_digitos = 0) {
      // Garante que o valor é uma string
      digitos = digitos.toString();

      // Faz a soma dos dígitos com a posição
      // Ex. para 10 posições:
      //   0    2    5    4    6    2    8    8   4
      // x10   x9   x8   x7   x6   x5   x4   x3  x2
      //   0 + 18 + 40 + 28 + 36 + 10 + 32 + 24 + 8 = 196
      for (var i = 0; i < digitos.length; i++) {
        // Preenche a soma com o dígito vezes a posição
        soma_digitos = soma_digitos + digitos[i] * posicoes;

        // Subtrai 1 da posição
        posicoes--;

        // Parte específica para CNPJ
        // Ex.: 5-4-3-2-9-8-7-6-5-4-3-2
        if (posicoes < 2) {
          // Retorno a posição para 9
          posicoes = 9;
        }
      }

      // Captura o resto da divisão entre soma_digitos dividido por 11
      // Ex.: 196 % 11 = 9
      soma_digitos = soma_digitos % 11;

      // Verifica se soma_digitos é menor que 2
      if (soma_digitos < 2) {
        // soma_digitos agora será zero
        soma_digitos = 0;
      } else {
        // Se for maior que 2, o resultado é 11 menos soma_digitos
        // Ex.: 11 - 9 = 2
        // Nosso dígito procurado é 2
        soma_digitos = 11 - soma_digitos;
      }

      // Concatena mais um dígito aos primeiro nove dígitos
      // Ex.: 025462884 + 2 = 0254628842
      var cpf = digitos + soma_digitos;

      // Retorna
      return cpf;
    },

    valida_cpf(valor) {
      valor = valor.toString();
      valor = valor.replace(/[^0-9]/g, "");
      var digitos = valor.substr(0, 9);
      var novo_cpf = this.calc_digitos_posicoes(digitos);
      novo_cpf = this.calc_digitos_posicoes(novo_cpf, 11);
      if (novo_cpf === valor) {
        return true;
      } else {
        return false;
      }
    },

    valida_cnpj(valor) {
      valor = valor.toString();
      valor = valor.replace(/[^0-9]/g, "");
      var cnpj_original = valor;
      var primeiros_numeros_cnpj = valor.substr(0, 12);
      var primeiro_calculo = this.calc_digitos_posicoes(
        primeiros_numeros_cnpj,
        5
      );
      var segundo_calculo = this.calc_digitos_posicoes(primeiro_calculo, 6);
      var cnpj = segundo_calculo;
      if (cnpj === cnpj_original) {
        return true;
      }
      return false;
    },

    valida_cpf_cnpj(valor) {
      var valida = this.verifica_cpf_cnpj(valor);
      valor = valor.toString();
      valor = valor.replace(/[^0-9]/g, "");
      if (valida === "CPF") {
        return this.valida_cpf(valor);
      } else if (valida === "CNPJ") {
        return this.valida_cnpj(valor);
      } else {
        return false;
      }
    },

    formata_cpf_cnpj(valor) {
      var formatado = false;
      var valida = this.verifica_cpf_cnpj(valor);
      valor = valor.toString();
      valor = valor.replace(/[^0-9]/g, "");
      if (valida === "CPF") {
        if (this.valida_cpf(valor)) {
          formatado = valor.substr(0, 3) + ".";
          formatado += valor.substr(3, 3) + ".";
          formatado += valor.substr(6, 3) + "-";
          formatado += valor.substr(9, 2) + "";
        }
      } else if (valida === "CNPJ") {
        if (this.valida_cnpj(valor)) {
          formatado = valor.substr(0, 2) + ".";
          formatado += valor.substr(2, 3) + ".";
          formatado += valor.substr(5, 3) + "/";
          formatado += valor.substr(8, 4) + "-";
          formatado += valor.substr(12, 14) + "";
        }
      }

      return formatado;
    },
    validateEmail(email) {
      console.log("Testando email");
      console.log(email);
      var re = /\S+@\S+\.\S+/;
      if (re.test(email) == false) {
        this.abrir_modal = true;
        this.email = "";
        this.msg = "Digite um email válido, ex: email@email.com!";
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    }
  }
};
</script>
